<template>
    <div class="scroll-content-horizonal section-dept" ref="scrollContent">
        <DeptNode 
            v-for="(item, index) in list"
            @handleExpand="handleExpand"
            @handleChecked="handleChecked"
            @getDeptChildList="getDeptChildList"
            :data="item"
            :key="index"
            :withMembers="withMembers" />
        <Load 
            v-if="!root.deptList"
      		:hasData="!!list.length"
            :hasMore="hasMore"
			:loading="loading" 
			@on-load="getDeptList"/>
        <Empty v-if="!loading && !hasMore && !list.length"/>
    </div>
</template>
<script>
    /**
     * 组织
     *  */
    import DeptNode from './section-dept-node'
    import ajax from '../../../../utils/ajax'
    import scroll from '../mixins/scroll'
    import section from '../mixins/section'
    import Empty from '../../../base/empty/'
    import Message from '../../../base/message/'
    import { t } from '../../../../locale/'

    export default {
        name: 'SectionDept',
        mixins: [scroll, section],
        inject: ['root'],
        props: {
            withMembers: {
                type: Boolean,
                default: false
            }
        },
        components: {
            DeptNode,
            Empty
        },
        methods: {
            getDeptList(deptId, params, checked) { // 拉取当前组织树
                const _this = this
                this.loading = true
                params && (params.loading = true)
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/${deptId || this.root.parentDeptId}/depts`,
                    params: {
                        withMembers: 1 - !(!!this.root.parentDeptId || deptId && this.withMembers),
                        type: this.root.chooseDeptType,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return _this.handleError(params || null)
                        }
                        let members = []
                        data.forEach(item => {
                            item.expand = false
                            item.checked = false
                            item.contain = false
                            item.children = []
                            item.loading = false
                            if(_this.withMembers) {
                                item.indeterminate = false
                            }
                            // 当存在父级， 并且为人员，只选择一级下面的人
                            if(params && item.type === 0 && _this.root.chooseDeptMemberType == 1) {
                                if(checked) {
                                    item.parent = params
                                    item.checked = checked
                                    _this.$emit('handleSelected', item)
                                }
                                members.push(item)
                            }
                        })

                        if(params && _this.root.chooseDeptMemberType == 1 && _this.withMembers) {
                            params.members = members
                        }

                        _this.loading = false
                        _this.hasMore = false
                        if(!deptId) {
                            return _this.list = _this.list.concat(data)
                        }
                        params && (params.children = data)
                        params && (params.loading = false)
                    },
                    error() {
                        _this.handleError(params || null)
                    }
                })
            },
            getMyDept() { // 获取我的部门
                const _this = this
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/dept`,
                    params: {
                        withMembers: 1 - !this.withMembers,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return _this.handleError()
                        }
                        data.forEach(item => {
                            item.userNum = 1
                            item.expand = false
                            item.checked = false
                            item.contain = false
                            item.children = []
                            if(_this.withMembers) {
                                item.indeterminate = false
                            }
                        })
                        if(data.length) _this.list.unshift(data[0])
                    },
                    error() {
                        _this.handleError()
                    }
                })
            },
            getDeptChildList(deptId, params, checked) { // 包含下级接口
                const _this = this;
                params.contain = !params.contain
                params.checked = params.contain
                this.$emit('handleSelected', params)
                if(params.data) {
                    return params.data.forEach(item => {
                        item.checked = params.contain
                        _this.$emit('handleSelected', item)
                    })
                }
                params.loading = true
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/${deptId}/sub_depts`,
                    params: {
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return _this.handleError(params)
                        }
                        data.forEach(item => {
                            item.checked = params.contain
                            _this.$emit('handleSelected', item)
                        })
                        params.loading = false
                        params.data = data
                    },
                    error() {
                        _this.handleError(params)
                    }
                })
            },
            getDeptMemberList(deptId, params, checked) { // 拉取当前组织下人员
                params.loading = true
                const _this = this
                ajax({
                    url: `${this.root.host}/cooperation/rest/v1/candidate/${this.root.qzId}/members`,
                    params: {
                        deptIds: [deptId],
                        size: 9999,
                        type: _this.root.chooseDeptType,
                        language: _this.root.language
                    },
                    success(res) {
                        let data = JSON.parse(res)
                        if(!Array.isArray(data)) {
                            return params.loading = false
                        }
                        data.forEach(item => {
                            item.parent = params
                            item.checked = !!checked
                            _this.$emit('handleSelected', item)
                        })
                        params.members = data
                        params.loading = false
                    },
                    error() {
                        params.loading = false
                    }
                })
            },
            handleExpand(expand, data) {
                data.expand = expand
                if(data.children && data.children.length) return
                this.getDeptList(data.deptId, data)
            },
            handleChecked(checked, data) {
                if(data.loading) return
                if(!this.withMembers || data.type === 0) { // 如果只选择组织或者单选人员
                    if(checked && 1 + this.root.selectedCount > this.root.limit) {
                        return Message.warning(t('selectMember.maximum'))
                    }
                    data.checked = checked
                    return this.$emit('handleSelected', data)
                }
                if(checked && data.userNum + this.root.selectedCount > this.root.limit) {
                    return Message.warning(t('selectMember.maximum'))
                }
                // 按照部门选择人员的时候
                data.indeterminate = checked
                if(data.members && data.members.length) {
                    return data.members.forEach(item => {
                        item.checked = !!checked
                        this.$emit('handleSelected', item)
                    })
                } 
                if(this.root.chooseDeptMemberType == 1) {
                    this.getDeptList(data.deptId, data, checked)
                } else {
                    this.getDeptMemberList(data.deptId, data, checked)
                }
            },
            init() {
                if(this.root.deptList) { // 如果传根组织列表了 一级为当前传入的组织
                    return this.list = this.root.deptList.map((item)=>{
                        return {
                            ...item,
                            loading: false,
                            checked: false,
                            expand: false,
                            indeterminate: false,
                            type: 1,
                            haveSub: 1,
                            userNum: 1,
                            children: []
                        }
                    })
                }
                this.getMyDept()
                this.getDeptList()
            }
        },
        created() {
            this.init()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/business/select-member/section/section-dept.vue